import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 md:px-8 bg-cream-100 text-navy-900" data-id="element-156">
      <div className="max-w-4xl mx-auto" data-id="element-157">
        <div className="text-center mb-12" data-id="element-158">
          <span className="text-4xl mb-4 block" data-id="element-159">🛡️</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-160">
            SECCIÓN 8 — GARANTÍA
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-161">
            "Tu Descanso Está Garantizado — El Riesgo Es Nuestro"
          </h3>
        </div>

        <div className="bg-white border-4 border-gold-500 p-8 md:p-12 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-162">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold-100 rounded-bl-full -mr-16 -mt-16 z-0" data-id="element-163"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-164">
            <div className="flex-shrink-0" data-id="element-165">
              <ShieldCheck className="h-24 w-24 text-gold-500" data-id="element-166" />
            </div>

            <div data-id="element-167">
              <h4 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-168">
                Garantía de 7 Noches Silenciosas
              </h4>
              <div className="prose prose-navy font-body text-navy-800" data-id="element-169">
                <p className="mb-4" data-id="element-170">Prueba la guía completa por 7 noches.</p>
                <p className="mb-4" data-id="element-171">
                  Sigue el sistema como está descrito — el checklist, el té, la
                  respiración, el menú.
                </p>
                <p className="mb-4 font-bold" data-id="element-172">
                  Si al cabo de 7 días no sientes una diferencia real en cómo
                  duermes y cómo amaneces — te devolvemos tu dinero completo.
                </p>
                <p data-id="element-173">
                  Sin preguntas. Sin trámites complicados. Sin explicaciones.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-cream-200 text-center md:text-left" data-id="element-174">
            <p className="text-navy-700 italic" data-id="element-175">
              ¿Por qué 7 días y no 30? Porque si el sistema funciona — y
              funciona — lo sentirás antes del día 5. Eso es lo que diseñamos.
              Eso es lo que garantizamos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}